<div class="nav-desktop" *ngIf="isDesktop">
  <div class="menu-container">
    <ng-template [ngTemplateOutlet]="verticalMenu"></ng-template>
  </div>
</div>

<div class="nav-tablet" *ngIf="isTablet">
  <div class="expander">
    <img src="../../assets/Nav/Hamburger_icon.svg" alt="menu" class="hamburger" (click)="expand(true)">
    <div class="skalaki-container">
      <img src="../../assets/Nav/Skalaki_grec.png" alt="skalaki" class="skalaki">
    </div>
  </div>
  <div class="menu-container">
    <ng-template [ngTemplateOutlet]="verticalMenu"></ng-template>
  </div>
</div>

<div class="nav-mobile" *ngIf="isMobile">
  <div class="expander">
    <div class="skalaki-container">
      <img src="../../assets/Nav/Skalaki_grec_h.png" alt="skalaki" class="skalaki">
    </div>
    <img src="../../assets/Nav/Hamburger_icon.svg" alt="ham" (click)="expand(true)">
  </div>
  <div class="menu-container">
    <ng-template [ngTemplateOutlet]="menuLinks"></ng-template>
  </div>
</div>

<ng-template #verticalMenu>
  <div class="cross" *ngIf="isTablet" (click)="expand(false)">
    <img src="../../assets/Nav/close.svg" alt="close">
  </div>
  <div class="header">
    <div class="logo">
      <img src="../../assets/logo.png" (click)="navigateHome()" alt="logo">
    </div>
  </div>
  <ng-template [ngTemplateOutlet]="menuLinks"></ng-template>
</ng-template>


<ng-template #menuLinks>
  <div class="menu">
    <div class="cross" *ngIf="isMobile">
      <img src="../../assets/Nav/close.svg" alt="close" (click)="expand(false)">
    </div>
    <a href="#" [class.active]="routeActive('description')" [routerLink]="['/description']" (click)="expand(false)">
      Description
    </a>
    <a href="#" [class.active]="routeActive('pictures')" [routerLink]="['/pictures']" (click)="expand(false)">
      {{'Photos'| translate}}
    </a>
    <a href="#" [class.active]="routeActive('equipment')" [routerLink]="['/equipment']" (click)="expand(false)">
      {{'Équipements' | translate}}
    </a>
    <a href="#" [class.active]="routeActive('availabilities')" [routerLink]="['/availabilities']"
      (click)="expand(false)">
      {{'Disponibilités' | translate}}
    </a>
    <a href="#" [class.active]="routeActive('prices')" [routerLink]="['/prices']" (click)="expand(false)">
      {{'Tarifs' |translate}}
    </a>
    <a href="#" [class.active]="routeActive('discover')" [routerLink]="['/discover']" (click)="expand(false)">
      {{'À découvrir' | translate}}
    </a>
    <a href="#" [class.active]="routeActive('usefull-addresses')" [routerLink]="['/usefull-addresses']"
      (click)="expand(false)">
      {{'Adresses utiles' | translate}}
    </a>
    <a href="#" [class.active]="routeActive('news')" [routerLink]="['/news']" (click)="expand(false)">
      News
    </a>
    <a href="#" [class.active]="routeActive('links')" [routerLink]="['/links']" (click)="expand(false)">
      {{'Liens' | translate}}
    </a>
    <a href="#" [class.active]="routeActive('reviews')" [routerLink]="['/reviews']" (click)="expand(false)">
      {{'Livre d\'or' | translate}}
    </a>
    <a href="#" [class.active]="routeActive('contact')" [routerLink]="['/contact']" (click)="expand(false)">
      Contact
    </a>
    <a *ngIf="isAdmin" href="#" [class.active]="routeActive('contact')" (click)="authService.logout()">
      Logout
    </a>
  </div>
  <div class="footer">
    <div class="media">
      <div (click)="openMedia('fb')">
        <i class="fab fa-facebook"></i>
      </div>
      <div (click)="openMedia('insta')">
        <i class="fab fa-instagram"></i>
      </div>
      <div (click)="openMedia('yt')">
        <i class="fab fa-youtube"></i>
      </div>
    </div>
    <div class="languages">
      <div (click)="changeLanguage('fr')" [class.active]="translate.currentLang === 'fr'">FR</div>
      <div (click)="changeLanguage('en')" [class.active]="translate.currentLang === 'en'">EN</div>
    </div>
  </div>
</ng-template>